import { inject, Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, Observable, of, switchMap, tap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService, Passport } from './services/auth.service';
import { UserService } from 'app/users/user.service';

import * as uuid from 'uuid';

@Injectable()
export class ApiTokenInterceptorInterceptor implements HttpInterceptor {

  unauthorizedUrl = '/invalid-permissions';
  
  constructor(private router: Router,
   private authService : AuthService,
   private userService : UserService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  
  if (request.url === '/usanapi/passport') {
    return next.handle(request).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          const modifiedData = event.body?.passportid;
          if (modifiedData) {
            sessionStorage.setItem('passportid', modifiedData);
          }
        }
      })
    );
  }

  
  const postExceptions = ['/usanapi/passport']; // Add more as needed

  
  const handleRequest = (req: HttpRequest<any>): Observable<HttpEvent<any>> => {
    const passportid = sessionStorage.getItem('passportid');

    if (passportid) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${passportid}`
        }
      });
    } else {
      //console.log(`am in interceptor ${JSON.stringify(req)}`);
      return next.handle(req).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 403) {
            this.router.navigate(['/']);
          }
          return of(new HttpResponse({
            status: error.status,
            statusText: error.statusText,
            headers: error.headers
          }));
        })
      );
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        //console.log(`interceptor catchError ${JSON.stringify(error)}`);
        if (this.isUnauthorized(error.status)) {
          this.router.navigate([this.unauthorizedUrl]);
          return of(new HttpResponse({
            status: error.status,
            statusText: error.statusText,
            headers: error.headers
          }));
        } else {
          //console.log(`intercept before throwError ${JSON.stringify(error)}`);
          if (
            error.error?.ErrorMessage &&
            typeof error.error.ErrorMessage === "string" &&
            error.error.ErrorMessage.includes("User Already")
          ) {
            return next.handle(req);
          }
          return throwError(() => error.error);
        }
      })
    );
  };

  const isPost = request.method === 'POST';
  const isException = postExceptions.some(path => request.url.includes(path));

  if (isPost && !isException ) {
    let token: Passport  = {
       id: uuid.v4(),
       uniqueId: this.userService.profile.uniqueId,
       orgId: this.userService.profile.orgId,
       roles: this.userService.profile.userRole,
       groups: this.userService.profile.groups
    }
    //console.log (`interceptor token ${JSON.stringify(token)}`)
    return this.authService.getToken(token).pipe(
      switchMap(() => handleRequest(request))
    );
  }

  return handleRequest(request);
}

   private isUnauthorized(status: number): boolean {
    return status === 403;
  }
}
